import { createFileRoute } from '@tanstack/react-router'

import { DistributionsProductPage } from '#/modules/intake/distributions-product-page'

export const Route = createFileRoute('/_shell/distributions')({
  component: DistributionsProductPage,
})
